import { LoadStatus } from '@evorait/pace-core';
import { MeasurementTools } from '../../types/measurement-tools';

export type MeasurementToolsState = Readonly<{
    tools: MeasurementTools[];
    toolsStatus: LoadStatus;
}>;

export const initialMeasurementToolsState: MeasurementToolsState = {
    tools: [],
    toolsStatus: LoadStatus.Idle,
};
